export const B2C_TEXTS = {
    BALANCE_TEXT: "Balance: ₹{0}",
    LOW_BALANCE_TEXT: "Balance: ₹{0} (Low)",
};

export const B2C_WIDGET_ACCESSIBILITY_ID = "b2c_widget_accessibility_wrapper";
